import PlanetDescriptionForm from '@/components/Astrology/BirthChart/PlanetDescription/PlanetDescriptionForm/PlanetDescriptionForm.vue';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import Loader from '@/components/Includes/Loader/Loader.vue';
import IPlanetDescription from "@/interfaces/astrology/birthChart/IPlanetDescription";
import {Action} from "vuex-class";

@Component({
    name: 'PlanetDescriptionDetail',
    components: {
        Loader,
        PlanetDescriptionForm
    }
})

export default class PlanetDescriptionDetail extends Vue {
    @Prop(String) private modalId!: string;
    @Prop(String) private modalTitle!: string;
    @Prop({type: Boolean, default: false}) private hideFooter!: boolean;
    @Prop(Boolean) private showModal!: boolean;
    @Prop(Object) private planetDescriptionData!: IPlanetDescription;

    // Begin Vuex Logic for PlanetDescription
    @Action private planetDescriptionChange!: (form: IPlanetDescription) => string;
    // End Vuex Logic for PlanetDescription

    private loading: boolean = true;

    private show: boolean | null = null;

    private get btnText(): {text: string, valid: boolean} {
        const valid = this.$validator.errors.items.length === 0;
        return {
            text: valid ? 'Update': 'Please enter the correct data',
            valid
        };
    }

    @Watch('showModal')
    private toggleModal(): void {
        this.show = this.showModal;
    }

    private closeModal() {
        this.loading = false;
        this.$emit('closeModalPlanetDescription')
    }

    private checkValidValues() {
        (this.$refs.PlanetDescriptionForm as HTMLFormElement).handleSave()
    }

    private async UpdatePlanetDescription(horoscopeData: IPlanetDescription) {
        try {
            this.loading = true;
            const status = await this.planetDescriptionChange(horoscopeData);
            this.loading = false;

            if (status === 'changed') {
                this.closeModal();

                this.$emit('UpdatePlanetDescription');

                this.$notify({
                    group: 'notice',
                    title: `Updated`,
                    text: 'Successfully',
                    type: 'success'
                });
            }
        } catch (error) {
            this.loading = false;
            throw new Error(error);
        }
    }

    private mounted() {
        this.loading = false;
    }
}